import { gql } from '@apollo/client';

export const GET_PROJECT_BY_ID = gql`
  query Project($id: ID!) {
    project(id: $id) {
      surveys {
        id
        surveyType
        questions {
          id
          label
          questionType
          questionOrder
          groupId
          leftLabel
          rightLabel
          blurVideo
          questionOptions {
            id
            label
            disqualify
            qualify
            order
          }
        }
        surveysPages {
          id
          pageName
          order
          skipLogic {
            conditions {
              id
              surveyPageId
              skipConditions {
                id
                questionId
                questionOptionId
                operation
              }
            }
          }
          displayQuestion {
            conditions {
              id
              questionsList
              displayConditions {
                id
                questionId
                questionOptionId
                operation
              }
            }
          }
          questions {
            id
            label
            questionType
            groupId
            questionOrder
            leftLabel
            rightLabel
            blurVideo
            questionOptions {
              id
              label
              disqualify
              qualify
              optionType
              order
              imageKey
              imageUrl
            }
          }
        }
      }
    }
  }
`;

export const SURVEYS_PAGES_ANSWERS = gql`
  query testerSurveyAnswers($testSessionId: ID!) {
    testerSurveyAnswers(testSessionId: $testSessionId) {
      answer
      answerOther
      questionId
      label
      firstName
      leftLabel
      rightLabel
      questionType
      pageId
      page
      questionOrder
      matrixType
      firstClickCoordinates {
        x
        y
      }
      answersMatrix
      answers {
        id
      }
      questionOptions {
        id
        label
        order
        imageKey
        imageUrl
        optionType
        matrixOption
      }
      rankingAnswers {
        order
        questionOptionId
        testSessionAnswerId
        label
      }
      imageUrl
    }
  }
`;
